import { FormikProps } from 'formik';
import t from 'utils/translationHelper';
import * as yup from 'yup';

import { BeneficiaryDto } from '@alpha/bene-dtos';
import { CurrencyAccountDto } from '@alpha/currency-accounts-dtos';
import { PaymentDto, PaymentFundingMethod, PaymentOnlineOrigin } from '@alpha/payments-dtos';

// Single Payment
export type FormikPaymentType = {
  id?: string,
  beneficiary?: BeneficiaryDto,
  amount?: number,
  date?: string | null,
  purpose?: string,
  reference?: string,
  emailAddresses: string[],
  singlePayment?: boolean,
  paymentOrigin: PaymentOnlineOrigin,
  fundingMethod: PaymentFundingMethod,
  tradeId?: string, // For adding payment AFTER booking Trade
  tradeDraftId?: string, // For fund payments by Spot flow, where trade is not booked yet
  invoiceNumber?: string, // For Service type payment purposes
  invoiceDate?: string, // For Service type payment purposes
  purposeType?: string,
  vopDetails?: PaymentDto['vopDetails'],
  vopRequired?: boolean,
  recommended?: boolean, // there is a COP recommendation for this payment
}

// Batch of Payments
export type FormikValueProps = FormikProps<FormikType>;
export type FormikType = {
  paymentCurrencyAccount?: CurrencyAccountDto;
  sellCurrencyAccount?: CurrencyAccountDto;
  payments?: FormikPaymentType[];
  isDraftPayment?: boolean;
  sellCurrencyCode?: string,
  paymentCurrencyCode?: string,
  tradeDraftId?: string,
  tradeId?: string,
  paymentOrigin: PaymentOnlineOrigin,
  fundingMethod: PaymentFundingMethod,
}
export const initialValues: FormikType = {
  paymentOrigin: PaymentOnlineOrigin.STANDALONE,
  fundingMethod: PaymentFundingMethod.CURRENCY_ACCOUNT_BALANCE,
};

export const validation = {
  paymentCurrencyAccount: yup
    .object({
      id: yup.string().required(),
    })
    .required(t('please_select_a_currency_account')),
};

export default validation;
